import { createAsyncThunk } from '@reduxjs/toolkit';
import NEWAPI from '../../API/newIndex';

export const getUser = createAsyncThunk('user/getUser', async (_, { rejectWithValue }) => {
  try {
    const res = await NEWAPI({
      url: '/admin/user/userInfo',
      method: 'GET',
    });

    return res?.data?.user ?? null;
  } catch (err) {
    return rejectWithValue(err);
  }
});